const config = {
  id: 24,
  name: '悬浮图标',
  type: 1,
  module_code: 'fix_icon',
  icon: 'icon-tms-bottom_nav',
  font_icon: '&#xe60b;',
  style_type: 1,
  property_data: {
    link_type: 1,
    link_data: [{
      memo: '建议尺寸:100px*100px'
    }],
    width: '',
    height: '',
    radius: '',
    right: '',
    bottom: '',
    open_download: 1,
  }
};
export default config;
